export default __webpack_public_path__ + "static/media/thyroid1.8ddc3364.jpg";